import { GzSelectionCardGroupWebComponent } from './component/GzSelectionCardGroupWebComponent';
import { GzSelectionCardWebComponent } from './component/GzSelectionCardWebComponent';

export { GzSelectionCardWebComponent, GzSelectionCardGroupWebComponent };
